
export function base64ToFile(base64Image: string, contentType: string|undefined): Blob {
  let data:string;
  let type:string|undefined;
  if(base64Image.indexOf(',')>-1){
    const split = base64Image.split(',');
    type = split[0].replace('data:', '').replace(';base64', '');
    data=split[1];
  }
  
  else{
    type=contentType?.replace('data:', '').replace(';base64', '');;
    data=base64Image;
  }  
  const byteString = window.atob(data);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i += 1) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], {type});
}

export const blobToBase64 = (blob: Blob): Promise<string> => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onerror = reject;
  reader.onload = () => {
    resolve(reader.result as string);
  };
  reader.readAsDataURL(blob);
});

export function base64ToArrayBuffer(imageBase64: string) {
  imageBase64 = imageBase64.replace(/^data\:([^\;]+)\;base64,/gmi, '');
  const binaryString = window.atob(imageBase64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

/*
export function base64ToBlob(base64String: string, contentType: string = ''): Promise<Blob> {
  return fetch(`data:${contentType};base64,${base64String}`)
    .then(response => response.blob());
}
*/

export function base64ToBlob(base64String: string, contentType: string = ''): Promise<Blob> {
  return new Promise((resolve) => {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: contentType });
    resolve(blob);
  });
}


